import type { WaveOpRecord, WaveDocumentSnapshot } from "@vida/wave-core";
import type { WaveBlipRecord } from "@vida/wave-core";

export const EMPTY_BLIPS: WaveBlipRecord[] = [];
export const EMPTY_OPS: WaveOpRecord[] = [];
export const EMPTY_SNAPSHOT: WaveDocumentSnapshot = Object.freeze({
  blocks: [],
  version: 1,
});

/** Avoid setState([]) loops — only replace when the array is non-empty. */
export function clearIfNonEmpty<T>(prev: T[]): T[] {
  return prev.length === 0 ? prev : [];
}
